'use client'

import Link from 'next/link'
import { ArrowRight, ExternalLink, Menu, Search, UtensilsCrossed } from 'lucide-react'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { BrandMark } from '@/components/brand/brand-mark'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet'

export function CustomerHeader({ surface = 'overlay' }: { surface?: 'overlay' | 'solid' }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const pathname = usePathname()
  const solid = surface === 'solid'

  return (
    <>
      <header className={`customer-nav ${solid ? 'customer-nav--solid' : ''}`}>
        <Link href="/" className="nav-logo"><BrandMark light={!solid} /></Link>
        <nav className="nav-links" aria-label="Main navigation">
          <Link href="/search" aria-current={pathname === '/search' ? 'page' : undefined}><Search /> Search</Link>
        </nav>
        <div className="nav-actions">
          <Button asChild variant="ghost" className="nav-business"><Link href="/for-restaurants">For restaurants <ExternalLink /></Link></Button>
          <Button asChild className="nav-book"><Link href={`/handler/sign-up?after_auth_return_to=${encodeURIComponent('/account/reservations')}`}>Sign up</Link></Button>
          <Button asChild variant="outline" className="nav-login"><Link href={`/handler/sign-in?after_auth_return_to=${encodeURIComponent('/account/reservations')}`}>Log in</Link></Button>
          <button className="nav-mobile" onClick={() => setMobileMenuOpen(true)} aria-label="Open menu"><Menu /></button>
        </div>
      </header>

      <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
        <SheetContent className="customer-menu-sheet" showCloseButton side="right">
          <SheetTitle className="sr-only">Trellis Tables menu</SheetTitle>
          <div className="customer-menu-auth">
            <Button asChild className="button button--burgundy"><Link href={`/handler/sign-up?after_auth_return_to=${encodeURIComponent('/account/reservations')}`}>Sign up</Link></Button>
            <Button asChild variant="outline"><Link href={`/handler/sign-in?after_auth_return_to=${encodeURIComponent('/account/reservations')}`}>Log in</Link></Button>
          </div>
          <nav className="customer-menu-booking" aria-label="Book with Trellis Tables">
            <Link href="/search" onClick={() => setMobileMenuOpen(false)}><UtensilsCrossed /> Dine in</Link>
          </nav>
          <nav className="customer-menu-account" aria-label="Customer account">
            <Link href="/reservations" onClick={() => setMobileMenuOpen(false)}>Your reservations</Link>
            <Link href="/notifications" onClick={() => setMobileMenuOpen(false)}>Notifications</Link>
            <Link href="/account/saved" onClick={() => setMobileMenuOpen(false)}>Saved restaurants</Link>
            <Link href="/account/settings" onClick={() => setMobileMenuOpen(false)}>Account <ArrowRight /></Link>
          </nav>
          <nav className="customer-menu-business" aria-label="Restaurant products"><Link href="/for-restaurants" onClick={() => setMobileMenuOpen(false)}>Use Trellis Tables at your restaurant <ExternalLink /></Link></nav>
          <div className="customer-menu-brand"><BrandMark /><span>Restaurant reservations</span></div>
        </SheetContent>
      </Sheet>
    </>
  )
}
